import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import App from './App.vue';
import router from './router/index';
import store from './store/index';
import i18n from './i18n';

import './filters';

// import Analytics from 'vue-analytics';
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;

const baseAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

Vue.use(VueAxios, baseAxios);

import VueCookies from 'vue-cookies-ts';
Vue.use(VueCookies);

function getParameterByName(name: string, url: string = '') {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let trackingEnabled = process.env.VUE_APP_PRODUCTION === 'true' && !getParameterByName('debug') && !getParameterByName('notracking');

if (!trackingEnabled) {
  Vue.cookies.set('PROMPT_TRACKING_DISABLED','1');
}

if (trackingEnabled && Vue.cookies.get('PROMPT_TRACKING_DISABLED')) {
  trackingEnabled = false;
  console.log('DISABLING TRACKING FROM COOKIE...');
}

console.log('TRACKING ENABLED: ', trackingEnabled);

// Vue.use(Analytics, {
//   id: 'UA-123474027-4',
//   router,
//   ignoreRoutes: ['dashboard.home'],
//   debug: {
//     sendHitTask: trackingEnabled,
//     enabled: !trackingEnabled,
//     // trace: !trackingEnabled
//   }
// })

Vue.use(VueGtag, {
  config: {id: "G-ZZKZBZQWWR"},
  enabled: trackingEnabled
}, router);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
